import React, { Component } from "react";
import PropTypes from "prop-types";
import { inject, observer } from "mobx-react";
import ReturnModes from "./ReturnModes";
import ReturnOrCancelReasons from "./ReturnOrCancelReasons";
import ReturnOrCancelRefund from "./ReturnOrCancelRefund";
import AddNEFT from "./AddNEFT";
import ReturnOrCancelComplete from "./ReturnOrCancelComplete";
import SelfShip from "./SelfShip";
import ReversePickUp from "./ReversePickUp";
import ReturnAddress from "./ReturnAddress";
import { RETURNS, CANCEL } from "npmlinks-constants";

const { RETURNFLOW, RETURN_COMPLETE, RETURN_ELIGIBLE } = RETURNS;
const { CANCELFLOW, CANCEL_ELIGIBLE } = CANCEL;

@inject("AddressStore", "LoginStore", "ReturnStore")
@observer
class Returns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: "returnOrCancelReason"
    };
    this.init = this.init.bind(this);
    this.inner = this.inner.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.setReversePickAddress = this.setReversePickAddress.bind(this);
    this.onFinalApiCall = this.onFinalApiCall.bind(this);
    this.init();
  }

  init() {
    const { itemId, orderId, ReturnStore } = this.props;
    const previousItemId = ReturnStore.itemId;
    if (previousItemId && previousItemId !== itemId) {
      ReturnStore.nukeReturnStoreData();
    }
    ReturnStore.setItemIdAndOrderIdToStore(itemId, orderId);
  }

  onFinalApiCall() {
    this.props.onSubmit();
  }
  setModelClassName() {
    if (this.state.currentView === "returnOrCancelComplete") {
      this.props.setClassName(RETURN_COMPLETE.CONFIRMATION_CLASS);
    } else {
      this.props.setClassName("");
    }
  }
  setReversePickAddress(addressId) {
    this.props.ReturnStore.setReturnAddressId(addressId);
    this.setState({ currentView: "returnModes" });
  }

  next(e) {
    if (e) e.preventDefault();
    const { type } = this.props;
    const { currentView } = this.state;
    if (type === RETURN_ELIGIBLE) {
      this.setState({
        currentView: RETURNFLOW[currentView].next
      });
    } else if (type === CANCEL_ELIGIBLE) {
      this.setState({
        currentView: CANCELFLOW[currentView].next
      });
    }
  }

  previous(e) {
    if (e) e.preventDefault();
    const { type } = this.props;
    const { currentView } = this.state;
    if (type === RETURN_ELIGIBLE) {
      this.setState({
        currentView: RETURNFLOW[currentView].previous
      });
    } else if (type === CANCEL_ELIGIBLE) {
      this.setState({
        currentView: CANCELFLOW[currentView].previous
      });
    }
  }

  inner(e) {
    if (e) e.preventDefault();
    const { type } = this.props;
    const { currentView } = this.state;
    if (type === RETURN_ELIGIBLE) {
      this.setState({
        currentView: RETURNFLOW[currentView].inner
      });
    } else if (type === CANCEL_ELIGIBLE) {
      this.setState({
        currentView: CANCELFLOW[currentView].inner
      });
    }
  }

  get currentViewSelector() {
    const { currentView } = this.state;
    const {
      closeModal,
      type,
      deliveredAddressId,
      itemId,
      orderId
    } = this.props;
    this.setModelClassName();
    switch (currentView) {
      case "returnOrCancelReason":
        return (
          <ReturnOrCancelReasons.component
            type={type}
            next={this.next}
            itemId={itemId}
            orderId={orderId}
            closeModal={closeModal}
          />
        );
      case "returnModes":
        return (
          <ReturnModes.component
            deliveredAddressId={deliveredAddressId}
            next={this.next}
            previous={this.previous}
            inner={this.inner}
          />
        );
      case "returnOrCancelRefund":
        return (
          <ReturnOrCancelRefund.component
            type={type}
            next={this.next}
            previous={this.previous}
            inner={this.inner}
            onSubmit={this.onFinalApiCall}
          />
        );
      case "addNeft":
        return <AddNEFT.component next={this.next} previous={this.previous} />;
      case "returnAddress":
        return (
          <ReturnAddress.component
            previous={this.previous}
            setReversePickAddress={this.setReversePickAddress}
            itemId={itemId}
          />
        );
      case "returnOrCancelComplete":
        return (
          <ReturnOrCancelComplete.component
            type={type}
            itemId={itemId}
            orderId={orderId}
          />
        );
      default:
        return (
          <ReturnOrCancelReasons.component
            type={type}
            next={this.next}
            closeModal={closeModal}
            itemId={itemId}
          />
        );
    }
  }
  render() {
    return <div>{this.currentViewSelector}</div>;
  }
}

Returns.defaultProps = {
  deliveredAddressId: "",
  itemId: ""
};

Returns.wrappedComponent.propTypes = {
  ReturnStore: PropTypes.shape({
    getReturnData: PropTypes.func.isRequired,
    setReturnAddress: PropTypes.func,
    setReturnAddressId: PropTypes.func
  }).isRequired,
  setClassName: PropTypes.func.isRequired,
  deliveredAddressId: PropTypes.string,
  itemId: PropTypes.string,
  orderId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired
};

const getFinalComponent = component =>
  inject("AddressStore", "LoginStore", "ReturnStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Returns.wrappedComponent,
  component: Returns
};
export {
  ReversePickUp,
  ReturnModes,
  ReturnOrCancelComplete,
  ReturnOrCancelReasons,
  AddNEFT,
  SelfShip,
  ReturnOrCancelRefund,
};

export default ProjectComponent;
